import { createFileRoute, notFound } from '@tanstack/react-router';

import {
  buildGuards,
  hasPermission,
  isAgencyCompany,
  isControllerCompany,
  isRetailLicensee,
  not,
} from '@mint-lib/routing-guards';

const guard = buildGuards(
  hasPermission('notificationsFeature:view'),
  not(isAgencyCompany),
  not(isControllerCompany),
  not(isRetailLicensee),
);

export const Route = createFileRoute('/_secured/notifications/')({
  async beforeLoad({ context }) {
    const guardsContext = await context.getGuardContext();
    if (!guard(guardsContext)) {
      throw notFound();
    }
  },
  async loader({ context }) {
    const i18n = await context.getInstance('i18n', '@mint/routing');

    await Promise.all([
      context.getInstance('i18n', '@myn/notifications-hub'),
      context.getInstance('i18n', '@mint-lib/ai-chat'),
      context.getInstance('i18n', '@mint-lib/tw-components'),
      context.getInstance('i18n', '@mint-lib/formatting-hooks'),
    ]);

    return {
      isReadOnly: !(await context.hasPermission('notificationsFeature:modify')),
      title: i18n.t('Notifications Hub | MINT'),
    };
  },
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData?.title,
      },
    ],
  }),
});
